import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { useState } from 'react';

import { useGlobalContext } from 'context/GlobalContext';
import { CustomBasicOptionsModal } from 'components/shared';

import useUpdateAccountLanguage from './useUpdateAccountLanguage';

/**
 * SelectLanguagePopup Component
 *
 * Component for selecting and changing the language in the application.
 * @example
 * <SelectLanguagePopup />
 */
export default function SelectLanguagePopup() {
  const { i18n, t } = useTranslation('global');
  const updateAccountLanguage = useUpdateAccountLanguage();
  const { userData } = useGlobalContext();
  const { instance } = useMsal();

  const [newIdiom, setNewIdiom] = useState<string>(null);

  const handleLanguageChange = () => {
    updateAccountLanguage.mutate(
      {
        langId: newIdiom === 'es' ? 1 : 2,
        id: userData.extension_GSerUserId
      },
      {
        onSuccess: async () => {
          localStorage.setItem('lang', newIdiom);
          await instance.logout();
        }
      }
    );
  };
  return (
    <div>
      <CustomBasicOptionsModal
        acceptSubmit={handleLanguageChange}
        btnAcceptText={t('common.commonActions.accept')}
        btnCancelText={t('common.commonActions.cancel')}
        cancelSubmit={() => setNewIdiom(null)}
        message={t('common.commonMessages.selectIdiom')}
        show={!!newIdiom}
      />
      <Box sx={{ p: 2 }}>
        <Typography textAlign="center">
          {t('general.selectALanguage')}
        </Typography>
        <Button
          color="primary"
          disabled={i18n.language === 'en'}
          onClick={() => setNewIdiom('en')}
          sx={{ m: 1 }}
          variant="contained"
        >
          English
        </Button>
        <Button
          color="primary"
          disabled={i18n.language === 'es'}
          onClick={() => setNewIdiom('es')}
          sx={{ m: 1 }}
          variant="contained"
        >
          Español
        </Button>
      </Box>
    </div>
  );
}
